__turbopack_context__.v({
  "cw-fade-up": "EdgeHubStage-module__rqeXJq__cw-fade-up",
  "cw-glow": "EdgeHubStage-module__rqeXJq__cw-glow",
  "hub-caret": "EdgeHubStage-module__rqeXJq__hub-caret",
  "hub-dot": "EdgeHubStage-module__rqeXJq__hub-dot",
  "hub-fade": "EdgeHubStage-module__rqeXJq__hub-fade",
  "hub-pop": "EdgeHubStage-module__rqeXJq__hub-pop",
  "hub-slide": "EdgeHubStage-module__rqeXJq__hub-slide",
  "hubCaret": "EdgeHubStage-module__rqeXJq__hubCaret",
  "hubFade": "EdgeHubStage-module__rqeXJq__hubFade",
  "hubPop": "EdgeHubStage-module__rqeXJq__hubPop",
  "hubSlide": "EdgeHubStage-module__rqeXJq__hubSlide",
  "hubThinking": "EdgeHubStage-module__rqeXJq__hubThinking",
  "stageIn": "EdgeHubStage-module__rqeXJq__stageIn",
  "stageNode": "EdgeHubStage-module__rqeXJq__stageNode",
});
